/**
 * This file will contain all the theme realted variables like colors, fontSize, fontWeight etc for the styled-components
 */
export const theme = {
  //Colors
  primeColor: "#e20049",
  blackColor: "#0e090d",
  greyColor: "#4f524f",

  //Font Weights
  fntWgtThin: "100",
  fntWgtLight: "200",
  fntWgtRegular: "400",
  fntWgtMedium: "500",
  fntWgtSBold: "600",
  fntWgtBold: "700",

  font2: "'Mochiy Pop One', sans-serif",
};
